import Vue from 'vue'
import Router from 'vue-router'

const ROUNTER_ARR = [
    {
        path: '/',
        name: 'updateHome',
        component: (resolve) =>
            require(['@/pages/updateHome/updateHome'], resolve)
    },
    // {
    //     path: '/',
    //     name: 'home',
    //     component: (resolve) => require(["@/pages/home/home"], resolve),
    // },
    // {
    //     path: '/expertDetail',
    //     name: 'expertDetail',
    //     component: (resolve) => require(["@/pages/expertDetail/expertDetail"], resolve),
    // },
    // {
    //     path: '/codeDetail',
    //     name: 'codeDetail',
    //     component: (resolve) => require(["@/pages/codeDetail/codeDetail"], resolve),
    // },
    // {
    //     path: '/sales',
    //     name: 'sales',
    //     component: (resolve) => require(["@/pages/invoice/sales/sales"], resolve),
    // },
    // {
    //     path: '/tax',
    //     name: 'tax',
    //     component: (resolve) => require(["@/pages/invoice/tax/tax"], resolve),
    // },
    // {
    //     path: '/income',
    //     name: 'income',
    //     component: (resolve) => require(["@/pages/invoice/income/income"], resolve),
    // },
    // {
    //     path: '/risk',
    //     name: 'risk',
    //     component: (resolve) => require(["@/pages/invoice/risk/risk"], resolve),
    // },
    // {
    //     path: '/approval',
    //     name: 'approval',
    //     component: (resolve) => require(["@/pages/approval/approval"], resolve),
    // },
    // {
    //     path: '/cloud',
    //     name: 'cloud',
    //     component: (resolve) => require(["@/pages/cloud/cloud"], resolve),
    // },
    {
        path: '/recruitPolicy',
        name: 'recruitPolicy',
        component: (resolve) =>
            require(['@/pages/recruitPolicy/recruitPolicy'], resolve),
        meta: {
            title: '壬华科技-财税数字化改革者-渠道伙伴赚钱模式'
        }
    },
    {
        path: '/recruitPolicyDetail',
        name: 'recruitPolicyDetail',
        component: (resolve) =>
            require(['@/pages/recruitPolicy/recruitPolicyDetail'], resolve),
        meta: {
            title: '壬华科技-财税数字化改革者-渠道伙伴赚钱模式'
        }
    },
    {
        path: '/newHome',
        name: 'newHome',
        component: (resolve) => require(['@/pages/newHome/newHome'], resolve),
        meta: {
            title: '壬华科技-财税数字化改革者-渠道伙伴赚钱模式'
        }
    },
    {
        path: '/updateSales',
        name: 'updateSales',
        component: (resolve) =>
            require(['@/pages/updateInvoice/updateSales/updateSales'], resolve)
    },
    {
        path: '/updateTax',
        name: 'updateTax',
        component: (resolve) =>
            require(['@/pages/updateInvoice/updateTax/updateTax'], resolve)
    },
    {
        path: '/updateIncome',
        name: 'updateIncome',
        component: (resolve) =>
            require([
                '@/pages/updateInvoice/updateIncome/updateIncome'
            ], resolve)
    },
    {
        path: '/updateRisk',
        name: 'updateRisk',
        component: (resolve) =>
            require(['@/pages/updateInvoice/updateRisk/updateRisk'], resolve)
    },
    {
        path: '/updateApproval',
        name: 'updateApproval',
        component: (resolve) =>
            require(['@/pages/updateApproval/updateApproval'], resolve)
    },
    {
        path: '/updateCloud',
        name: 'updateCloud',
        component: (resolve) =>
            require(['@/pages/updateCloud/updateCloud'], resolve)
    },
    {
        path: '/updateCodeDetail',
        name: 'updateCodeDetail',
        component: (resolve) =>
            require(['@/pages/updateCodeDetail/updateCodeDetail'], resolve)
    },
    {
        path: '/updateExpertDetail',
        name: 'updateExpertDetail',
        component: (resolve) =>
            require(['@/pages/updateExpertDetail/updateExpertDetail'], resolve)
    },
    {
        path: '/agent',
        name: 'agent',
        component: (resolve) => require(['@/pages/agent/agent'], resolve)
    },
    {
        path: '/agent/apply',
        name: 'apply',
        component: (resolve) => require(['@/pages/agent/apply/apply'], resolve)
    },
    {
        path: '/agent/webView',
        name: 'webView',
        component: (resolve) => require(['@/pages/agent/apply/webView'], resolve)
    },
    {
        path: '/agent/apply-success',
        name: 'apply-success',
        component: (resolve) => require(['@/pages/agent/applySuccess/applySuccess'], resolve)
    },
    {
        path: '/test',
        name: 'test',
        component: (resolve) => require(['@/pages/test/test'], resolve)
    },
    {
        path: '/agent/pc/register',
        name: 'agentPCRegister',
        component: (resolve) => require(['@/pages/agent/register/pc'], resolve)
    },
    {
        path: '/agent/mobile/register',
        name: 'agentMobileRegister',
        component: (resolve) => require(['@/pages/agent/register/mobile'], resolve)
    },
    {
        path: '/agent/pc/register/agent',
        name: 'agentPCRegisterAgent',
        component: (resolve) => require(['@/pages/agent/register/pc/agent'], resolve)
    },
    {
        path: '/agent/mobile/register/agent',
        name: 'agentMobileRegisterAgent',
        component: (resolve) => require(['@/pages/agent/register/mobile/agent'], resolve)
    },
    {
        path: '/agent/mobile/register/success',
        name: 'agentMobileRegistersuccess',
        component: (resolve) => require(['@/pages/agent/register/mobile/success'], resolve)
    },
    {
        path: '/agent/mobile/guidePages',
        name: 'agentMobileGuidePages',
        component: (resolve) => require(['@/pages/agent/guidePages/mobile/guidePages'], resolve)
    }
]

Vue.use(Router)
var routes = new Router({
    mode: 'history', //去掉url中的#
    routes: ROUNTER_ARR
})

routes.beforeEach(({ meta, path }, from, next) => {
    // 自动改变页面title
    document.title = meta.title || '壬华（深圳）科技有限公司'
    localStorage.setItem('path_url', path)
    next()
})

export default routes



// WEBPACK FOOTER //
// ./src/router/index.js